(function() {
  window.adConfigs = window.adConfigs || {};

  const selftreatImages = {
    'caramel':       'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Self_Treat_Caramel.png?v=1776269836',
    'peanutbutter':  'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Self-Treat-Peanut-Butter-PDP.png?v=1775653052',
    'pistachio':     'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Pistachio_self_treat.png?v=1776268428',
    'raspberry':     'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Raspberry_cropped.png?v=1774430529',
    'pretzel':       null,
    'smaltz':        'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Self-treat-smaltz.png?v=1776079070',
    'smaltz2':       'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/SelfTreat-Smaltz-PDP.png?v=1776264730',
    'smaltzbranded': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Smaltz_logo_self_treat.png?v=1776428059',
    'peanutbutterlinen': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Self_treat_peanut_butter_linen.png?v=1776777114',
    'peanutbutternapkin': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Peanut_butter_self_treat_napkin.png?v=1776786052',
    'peanutbutterplate': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Peanut_butter_bar_on_plate.png?v=1776790478',
    'carameldiagonalupwardswithloop': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Self_Treat_Caramel_Loop_diagonal_upwards_PDP.png?v=1777372469',
        'tableflowersbox': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Box-coffee-table-flowers.png?v=1777986610',
            'icedmatchstainlesssteel': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Matcha-Ice-Dollar-Stainlesssteel-Cropped.png?v=1777988411',
                'boxonyellowtable': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Box_on_yellow_table_cloth.png?v=1777989822',


  };

  const selftreatFlavours = {
    'caramel':       'Caramel',
    'peanutbutter':  'Peanut Butter',
    'pistachio':     'Pistachio',
    'raspberry':     'Raspberry',
    'pretzel':       'Hazelnut',
    'smaltz':        'Malt Cornflakes',
    'smaltz2':       'Malt Cornflakes',
    'smaltzbranded': 'Malt Cornflakes',
    'peanutbutterlinen': 'Peanut Butter',
    'peanutbutternapkin': 'Peanut Butter',
    'peanutbutterplate': 'Peanut Butter',
    'carameldiagonalupwardswithloop': 'Caramel',
        'tableflowersbox': 'Caramel',
        'icedmatchstainlesssteel': 'Caramel',
        'boxonyellowtable': 'Caramel',
  };

  const subtitle = "Not a gift. This one's for you.";
  const socialProof = '★★★★★ Best chocolate I\'ve had in ages';

  Object.entries(selftreatFlavours).forEach(([key, displayName]) => {
    const pdpImage = selftreatImages[key];

// No cart image change for build a box
    window.adConfigs[`selftreat-bab-${key}`] = {
      subtitle,
      heroImage:  pdpImage,
      cartImage:  null,
      socialProof,
      flavour:    displayName,
    };
  });
})();